/**
 * AUTO-GENERATED by generate-company-info.cts — 직접 수정하지 말 것.
 * source: libs/shared/company-info(워크스페이스 법인정보 단일 출처).
 *
 * 값을 바꾸려면 libs/shared/company-info를 고친 뒤
 * `pnpm nx run client-app-footer:generate-company-info`로 재생성할 것 —
 * client-app-footer:test가 drift(재생성 잊음)를 CI에서 잡는다.
 */
export const COMPANY_INFO = {
  name: '주식회사 학교종이',
  ceo: '대표 김형균',
  callNumber: '대표번호 1522-1225',
  businessRegistrationNumber: '사업자 등록번호 326-86-00361',
  mailOrderBusinessNumber: '통신판매업 신고번호 제2023-세종-0869호',
  address: '세종특별자치시 한누리대로 1966 (소담동, 301호 로이어즈타워)',
  addressMapUrl: 'https://maps.app.goo.gl/NZ5uUHTdEHaQQ3hw9',
} as const;
